import { BodyMD, Heading2XL, Heading5XL, HeadingLG } from "../../../typography";

import { ContactForm } from "./ContactForm";
import { WOUND_CARE_ORDER_FORM_URL } from "../../../../constants";
import { cn } from "@verse_core/shared_components/ClassName";
import { config } from "../config/contact";

export const Hero = () => {
  return (
    <div className="tw-relative tw-flex tw-items-center tw-gap-y-[32px]">
      <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-y-[42px] min440:tw-px-[24px] min840:tw-flex-row min840:tw-gap-x-[4em]">
        <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-y-[4em] tw-text-center min440:tw-items-start min840:tw-w-1/2 min840:tw-text-left">
          <Heading5XL className="tw-my-0 tw-hidden tw-text-white min440:tw-flex">
            Get started with Verse Medical
          </Heading5XL>
          <Heading2XL className="tw-my-0 tw-text-white min440:tw-hidden">
            Get started with Verse Medical
          </Heading2XL>
          <div className="tw-flex tw-w-full tw-flex-col tw-gap-y-[1.5em] tw-divide-x-0 tw-divide-y tw-divide-solid tw-divide-white tw-divide-opacity-15 tw-text-left">
            {config.map((item, idx) => {
              return (
                <div
                  key={`contact-item-${idx}`}
                  className={`tw-flex tw-flex-col tw-gap-y-[8px]`}
                >
                  <div
                    className={cn(
                      "tw-flex tw-flex-row tw-items-center tw-gap-x-[1.5em]",
                      idx !== 0 && "tw-pt-[1.5em]",
                    )}
                  >
                    <img
                      src={item.icon}
                      alt={item.titles[0]}
                      className="tw-h-[56px] tw-w-[56px]"
                    />
                    <div className="tw-flex tw-flex-col tw-gap-y-[0.25em]">
                      {item.titles.map((title, idx) => (
                        <HeadingLG
                          key={`contact-item-title-${idx}`}
                          className="tw-my-0 tw-text-white"
                        >
                          {title}
                        </HeadingLG>
                      ))}
                      <BodyMD className="tw-my-0 tw-text-gray-light-0">
                        {item.description}{" "}
                        {item.descriptionAccent && (
                          <a
                            href={WOUND_CARE_ORDER_FORM_URL}
                            className="tw-cursor-pointer tw-text-white tw-underline hover:tw-text-white"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item.descriptionAccent}
                          </a>
                        )}
                      </BodyMD>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="tw-w-full min840:tw-w-1/2">
          <ContactForm />
        </div>
      </div>
    </div>
  );
};
